module.exports = "/assets/_next/static/images/wand-complete-b633fe6335e954e44ef51c5ac0820b35.png";